export function filterOptions(allOptions, ownerValue, filterConfig, allValues = {}) {
  if (!filterConfig || !Array.isArray(allOptions)) return allOptions ?? [];

  const { strategy, map } = filterConfig;

  if (strategy === 'templateWhitelist') {
    const tmpl = allValues.__templateShortName ?? '';
    const allowed = map?.[tmpl];
    if (!allowed) return allOptions;
    return allOptions.filter(opt => allowed.includes(String(opt.value)));
  }

  if (strategy === 'templateSubstring') {
    const tmpl = allValues.__templateShortName ?? '';
    if (!map?.[tmpl]) return allOptions;
    return allOptions.filter(
      opt => opt.value === '-1' || tmpl.includes(String(opt.value))
    );
  }

  if (!ownerValue || ownerValue === '-1') return allOptions;
  const mapped = map?.[ownerValue];
  if (!mapped) return allOptions;

  switch (strategy) {
    case 'valueStartsWith': {
      const prefix = String(mapped);
      return allOptions.filter(opt =>
        opt.value === '-1' || String(opt.value).startsWith(prefix)
      );
    }

    case 'valueIn': {
      const allowList = Array.isArray(mapped) ? mapped : [mapped];
      return allOptions.filter(opt => allowList.includes(opt.value));
    }

    case 'always': {
      const allowList = Array.isArray(mapped) ? mapped : [mapped];
      return allOptions.filter(opt => allowList.includes(opt.value));
    }

    default:
      console.warn(`[FieldEngine] Unknown option filter strategy: "${strategy}"`);
      return allOptions;
  }
}
